import React, { memo } from 'react';
import { RegisterMenuForm } from '../../organisms/menu/RegisterMenuForm';
import { useParams } from 'react-router-dom';
import { useRegisterEnglishMenuImages } from '../../../hooks/menu/useRegisterEnglishMenuImages';


export const EnglishDrinkMenuRegister: React.FC = memo(() => {
  const { restaurantId } = useParams()
  const onSubmit = useRegisterEnglishMenuImages('drink', restaurantId)
  return <RegisterMenuForm menuName='ドリンク' onSubmit={onSubmit} />;
});